import { render, staticRenderFns } from "./BetgameEditUser.vue?vue&type=template&id=0aff8a54&scoped=true"
import script from "./BetgameEditUser.vue?vue&type=script&lang=js"
export * from "./BetgameEditUser.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditUser.vue?vue&type=style&index=0&id=0aff8a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff8a54",
  null
  
)

export default component.exports